(function () {
  var COUNTDOWN_SELECTOR = "[data-project-prolong-countdown]";
  var HOUR_SELECTOR = "[data-countdown-hours]";
  var MINUTE_SELECTOR = "[data-countdown-minutes]";
  var SECOND_SELECTOR = "[data-countdown-seconds]";
  var HERO_IMAGE_SELECTOR =
    "[data-project-prolong-page] .project-prolong__hero-media img";
  var SWIPER_SELECTOR = "[data-project-prolong-swiper]";
  var REDUCE_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  function pad(value, length) {
    return String(value).padStart(length, "0");
  }

  function updateCountdown(countdown, endTime) {
    var remainingMilliseconds = Math.max(0, endTime - Date.now());
    var remainingSeconds = Math.floor(remainingMilliseconds / 1000);
    var hours = Math.floor(remainingSeconds / 3600);
    var minutes = Math.floor((remainingSeconds % 3600) / 60);
    var seconds = remainingSeconds % 60;
    var hoursText = pad(hours, 3);
    var minutesText = pad(minutes, 2);
    var secondsText = pad(seconds, 2);
    var time = countdown.matches("time")
      ? countdown
      : countdown.querySelector("time");

    var hoursElement = countdown.querySelector(HOUR_SELECTOR);
    var minutesElement = countdown.querySelector(MINUTE_SELECTOR);
    var secondsElement = countdown.querySelector(SECOND_SELECTOR);

    if (hoursElement) hoursElement.textContent = hoursText;
    if (minutesElement) minutesElement.textContent = minutesText;
    if (secondsElement) secondsElement.textContent = secondsText;

    if (time) {
      time.dateTime = "PT" + hours + "H" + minutes + "M" + seconds + "S";
      time.setAttribute(
        "aria-label",
        "残り時間 " +
          hoursText +
          "時間 " +
          minutesText +
          "分 " +
          secondsText +
          "秒",
      );
    }

    return remainingMilliseconds === 0;
  }

  function initializeCountdown(countdown) {
    var endTime = Date.parse(countdown.dataset.countdownEnd);

    if (Number.isNaN(endTime)) {
      updateCountdown(countdown, Date.now());
      return;
    }

    if (updateCountdown(countdown, endTime)) return;

    var intervalId = window.setInterval(function () {
      if (updateCountdown(countdown, endTime)) {
        window.clearInterval(intervalId);
      }
    }, 1000);
  }

  function initializeProductSwipers() {
    if (typeof window.Swiper !== "function") return;

    var prefersReducedMotion = window.matchMedia(REDUCE_MOTION_QUERY).matches;

    document.querySelectorAll(SWIPER_SELECTOR).forEach(function (element) {
      if (element.swiper) return;

      new window.Swiper(element, {
        loop: true,
        speed: 500,
        autoplay: prefersReducedMotion
          ? false
          : {
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
        pagination: {
          el: element.querySelector(".swiper-pagination"),
          clickable: true,
        },
        watchOverflow: true,
      });
    });
  }

  function initialize() {
    var heroImage = document.querySelector(HERO_IMAGE_SELECTOR);

    if (heroImage) heroImage.loading = "eager";

    document.querySelectorAll(COUNTDOWN_SELECTOR).forEach(initializeCountdown);
    initializeProductSwipers();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
